import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolders2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"folders-2, collection, stuff"} maskId="square-filled-radius-0-stroke-1-IconFolders2"><path d="M3 19H19V20H2V6H3V19Z" fill="currentColor"/><path d="M13.707 5.5H22V17H5V3H11.207L13.707 5.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFolders2;
